import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState, AUTH_STATE_SLICE } from './auth.state';

const selectFeature = createFeatureSelector<AuthState>(AUTH_STATE_SLICE);

export const selectIsAuthenticated = createSelector(selectFeature, (state) => !!state.profile);

export const selectUserProfile = createSelector(selectFeature, (state) => state.profile);

export const selectAccessToken = createSelector(
  selectFeature,
  (state) => state.token?.accessToken || '',
);

export const selectClientId = createSelector(
  selectFeature,
  (state) => state.profile?.clientId || '',
);

export const selectHasError = createSelector(selectFeature, (state) => state.error);

export const selectTokens = createSelector(selectFeature, (state) => ({
  clientId: state.profile?.clientId,
  accessToken: state.token?.accessToken || '',
}));
